import React, { useState, useEffect } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { Loader, Text, View } from '@aws-amplify/ui-react';
import { API } from 'aws-amplify';
import { FaHome } from 'react-icons/fa';

function PlaylistViewer() {
  const { playlistId } = useParams();
  const location = useLocation();
  const [playlist, setPlaylist] = useState(location.state?.playlist || null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isHtml, setIsHtml] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    fetchPlaylistContent();
  }, [playlistId]);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchPlaylistContent = async () => {
    if (!playlistId) {
      setError('Playlist ID is required');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await API.get('PlaylistsAPI', 'playlist-content', {
        queryStringParameters: {
          id: playlistId
        },
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response) {
        if (response.playlist) {
          setPlaylist(response.playlist);
        }
        
        setContent(response.content || '');
        setIsHtml(response.isHtml || false);
        console.log('Playlist content loaded successfully');
      } else {
        setError('Failed to load playlist content');
      }
    } catch (err) {
      console.error('Error loading playlist content:', err);
      setError('Failed to load playlist content: ' + (err.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return <Loader size="large" />;
  }

  if (error) {
    return (
      <View padding="1rem">
        <Link to="/" style={{ display: 'block', marginBottom: '1rem' }}>← Back to Home</Link>
        <Text variation="error">{error}</Text>
      </View>
    );
  }

  return (
    <View padding="0.5rem 0.5rem">
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: '#1976D2', fontWeight: 'bold', fontSize: '1.1rem', paddingRight: '0.5rem' }}>
          <FaHome style={{ fontSize: '1.3rem', verticalAlign: 'middle' }} />
          Nama Home!
        </Link>
      </div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
          {playlist?.name || `Playlist ${playlistId}`}
        </h1>
        {playlist && (
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            ID: {playlist.id}
          </div>
        )}
      </div>
      <div style={{
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '1rem', // reduced padding
        whiteSpace: 'pre-wrap',
        fontFamily: "'Nirmala UI', 'Mangal', Arial, sans-serif",
        lineHeight: '1.5'
      }}>
        {isHtml ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          content
        )}
      </div>
      {/* Scroll to Top Button */}
      <button
        style={{
          position: 'fixed',
          bottom: '1.5rem',
          right: '2.5rem', // further left
          width: '2.4rem',
          height: '2.2rem',
          backgroundColor: 'rgba(25, 118, 210, 0.7)',
          color: 'white',
          boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
          display: showScrollTop ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.3rem',
          transition: 'background 0.2s',
          backdropFilter: 'blur(2px)',
          maxWidth: '100vw',
          overflow: 'hidden',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          zIndex: 1000
        }}
        title="Scroll to top"
        onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(25, 118, 210, 0.95)'}
        onMouseOut={e => e.currentTarget.style.backgroundColor = 'rgba(25, 118, 210, 0.7)'}
        onClick={scrollToTop}
      >
        ↑
      </button>
    </View>
  );
}

export default PlaylistViewer;